class GlobalVariables {
    private static variables: { [key: string]: any } = {};

    public static set(key: string, value: any): void {
        GlobalVariables.variables[key] = value;
    }

    public static get(key: string): any {
        return GlobalVariables.variables[key];
    }
}
export default GlobalVariables;

// The global variables
export const GLOBAL_VARIABLES = {
    ENV: 'production',
    API_PATHS: 'api_paths',
    ANTI_HIT: 'anti_hit',
    CHANNEL: '',
    CS_HIT: 'cs_hit'
}